import React, { useState } from "react";
import blogs from "../data/blogs";
import BlogCarousel from "../components/BlogCarousel";

export default function CreateLabel() {
  const [formData, setFormData] = useState({
    customerName: "",
    customerAddress: "",
    customerPincode: "",
    customerPhone: "",
    sellerName: "",
    sellerAddress: "",
    sellerPincode: "",
    sellerPhone: ""
  });

  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setDownloadUrl(null);
    setError(null);
  };

  const handleGenerate = async () => {
    setLoading(true);
    setDownloadUrl(null);
    setError(null);

    try {
      const res = await fetch("https://your-backend-api.com/generate-label", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setDownloadUrl(url);
    } catch (err) {
      setError("Generation failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow p-6 sm:p-10 text-toast-blue">
        <h2 className="text-2xl font-bold text-center mb-8">Generate Your Shipping Label at Ease</h2>

        <div className="grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Customer Info */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Customer Details</h3>
            <input name="customerName" placeholder="Customer Name" className="input-box" onChange={handleChange} />
            <input name="customerAddress" placeholder="Customer Address" className="input-box" onChange={handleChange} />
            <input name="customerPincode" placeholder="Pincode" className="input-box" onChange={handleChange} />
            <input name="customerPhone" placeholder="Phone Number" className="input-box" onChange={handleChange} />
          </div>

          {/* Seller Info */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Seller Details</h3>
            <input name="sellerName" placeholder="Seller Name" className="input-box" onChange={handleChange} />
            <input name="sellerAddress" placeholder="Seller Address" className="input-box" onChange={handleChange} />
            <input name="sellerPincode" placeholder="Pincode" className="input-box" onChange={handleChange} />
            <input name="sellerPhone" placeholder="Phone Number" className="input-box" onChange={handleChange} />
          </div>
        </div>

        <div className="text-center mt-8">
          <button
            onClick={handleGenerate}
            disabled={loading}
            className="bg-toast-blue text-white px-6 py-3 rounded hover:bg-toast-red transition"
          >
            {loading ? "Generating..." : "Generate Label"}
          </button>
          {error && <p className="text-red-600 mt-3">{error}</p>}
          {downloadUrl && (
            <div className="mt-6">
              <p className="text-green-600 mb-2">Label generated successfully!</p>
              <a
                href={downloadUrl}
                download={`Shipping_Label_${Date.now()}.pdf`}
                className="bg-green-600 text-white px-5 py-2 rounded hover:bg-green-700"
              >
                Download PDF
              </a>
            </div>
          )}
        </div>

        {/* How It Works */}
        <section className="mt-16 text-center">
          <h2 className="text-xl font-bold mb-4">How It Works</h2>
          <div className="grid sm:grid-cols-3 gap-4 text-toast-blue">
            <div>
              <div className="text-4xl mb-2">🧾</div>
              <p>Fill in customer and seller details</p>
            </div>
            <div>
              <div className="text-4xl mb-2">⚙️</div>
              <p>Tool generates your label</p>
            </div>
            <div>
              <div className="text-4xl mb-2">📥</div>
              <p>Download and print the label</p>
            </div>
          </div>
        </section>
      </div>
<div className="mt-10">
  <BlogCarousel />
</div>
      {/* Footer */}
      <footer className="text-sm text-gray-500 mt-4 pt-2 pb-2 border-t text-center">
        © 2025 by Drenx Technologies. All rights reserved.
        <div className="mt-1 flex justify-center gap-4 text-blue-600">
          <a href="#" className="hover:underline">📘 Facebook</a>
          <a href="#" className="hover:underline">📸 Instagram</a>
          <a href="#" className="hover:underline">▶️ YouTube</a>
        </div>
      </footer>
    </div>
  );
}
